import Container from "@/components/common/Container";
import PrimaryButton from "@/components/common/PrimaryButton";
import { LINK_OF_ALL_PAGES } from "const/common";
import Image from "next/image";
import Link from "next/link";

const LookingForOtherSolutions = ({ data }) => {
  const { lookingOtherSolutionsData } = data;
  return (
    <Container large className="bg-primary-black py-20 lg:py-40">
      <h2 className="text-4xl md:text-3xl lg:text-6xl mb-8 md:mb-4 lg:mb-7 font-medium text-white text-center">
        <span>Looking for other Solutions?</span>
      </h2>
      <p className="text-white text-base text-center mx-auto">
        <span>
          Here we are presenting other related technology options to dive you
          into proper guidance, which will help you to select the best
          technology for your project as well as for hiring developers.
        </span>
      </p>
      <div className="flex flex-col lg:flex-row pt-16 pb-8 px-4 gap-4 md:p-16 lg:pt-32 lg:pb-24 lg:px-0 md:gap-24 justify-around">
        {lookingOtherSolutionsData.map((value) => (
          <div
            key={value.techName}
            className="lg:w-3/12 bg-[rgba(44,36,36,0.5)] rounded-2xl transition-all ease-in duration-1000 hover:scale-125 hover:transition-all hover:ease-in hover:duration-1000 my-12 md:my-8 lg:my-0"
          >
            <Link passHref href={value.link}>
              <a>
                <div className="flex flex-col items-center p-4">
                  <div className="relative bottom-16">
                    <Image
                      alt={value.iconAlt}
                      height={113}
                      loading="lazy"
                      src={value.icon}
                      width={112}
                    />
                  </div>
                  <p className="text-base font-light text-white relative bottom-8">
                    <span>{value.techName}</span>
                  </p>
                </div>
              </a>
            </Link>
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <PrimaryButton
          link={LINK_OF_ALL_PAGES.mainPages.contactUs}
          val={"Contact us Now"}
        />
      </div>
    </Container>
  );
};

export default LookingForOtherSolutions;
